$.fn.SLR_InvoiceActions = function()
{
	var _actions = this;
	if (_actions.data("init") == true) return;
	_actions.data("init", true);
	_actions.invoice_data = _actions.data("invoice");
	_actions.email_composer = undefined;

	_actions.submit_action = function(action, permission_key, permission_value)
	{
		// gather data
		var request = new FormData(),
		data = {};

		// build request
		request.append("model", "invoice");
		request.append("id", _actions.invoice_data.id);
		request.append("action", action);
		if (permission_key != undefined && permission_value != undefined){
			data[permission_key] = permission_value;
		}
		request.append("data", JSON.stringify(data));

		// add request to queue
		$.slr.db.add(request, _actions.saved);
		return false;
	};

	_actions.print = function()
	{
		var print_icon = $(this).find("i");
		$('.print-frame').remove();
		print_icon.removeClass("fa-print").addClass("fa-circle-o-notch fa-spin");
		var iframe = $('<iframe></iframe>').attr("src", "/assets/libraries/pdfjs/web/viewer.html?file=" + $(this).attr("href")).css({
			width : '1px',
			height : '1px',
			position : 'fixed',
			top : '-1px',
			left : '-1px'
		}).addClass("print-frame");
		$("body").append(iframe);
		window.endPrintProcess = function(){
			print_icon.removeClass("fa-circle-o-notch fa-spin").addClass("fa-print");
		};
		return false;
	};

	_actions.email = function()
	{
		_actions.email_composer = $('#email-modal').clone().EmailComposer(_actions.invoice_data);
		$(_actions.email_composer).modal('show');
		return false;
	};

	_actions.delete = function()
	{
		$(".delete-invoice-swal").remove();
		swal({
			title: "Suppression d'une facture",
			text: "Êtes-vous sûr de vouloir supprimer cette facture? Cette action est protégée par mot de passe.",
			type: "input",
			customClass: "delete-invoice-swal",
			showCancelButton: true,
			cancelButtonText: 'Annuler',
			confirmButtonClass: "btn-danger",
			confirmButtonText: 'Supprimer',
			closeOnConfirm: false,
			inputPlaceholder: "Mot de passe"
		}, function (inputValue){
			$.post("/login/permission", {
				privilege: 'INVOICE_DELETE',
				password: inputValue
			}, function(x){
				if (x.success){
					// got permission, delete using key
					_actions.submit_action("delete", x.action, x.key);
				} else {
					// didn't get permission
					swal({
						title: "Erreur",
						text: "Mot de passe incorrect.",
						type: "error",
						confirmButtonClass: "btn-danger"
					});
				}
			}, 'json');
		});
		$(".delete-invoice-swal").find(".form-control").attr("type", "password").attr("autocomplete", "new-password").css({
			'width' : "200px",
			'margin' : "0 auto 1.5em"
		});
	};

	_actions.publish = function()
	{
		swal({
			title: "Publication d'une facture",
			text: "Êtes-vous sûr de vouloir publier\net verrouiller cette facture?",
			type: "warning",
			showCancelButton: true,
			cancelButtonText: 'Annuler',
			confirmButtonClass: "btn-primary",
			confirmButtonText: 'Publier et verrouiller',
			closeOnConfirm: true
		}, function(){
			_actions.submit_action("publish");
		});
		return false;
	};

	_actions.discard = function()
	{
		swal({
			title: "Annuler les changements",
			text: "Êtes-vous sûr de vouloir annuler vos changements?\nLa facture originale sera rétablie.",
			type: "warning",
			showCancelButton: true,
			cancelButtonText: 'Conserver',
			confirmButtonClass: "btn-primary",
			confirmButtonText: 'Rejeter les changements',
			closeOnConfirm: true
		}, function(){
			_actions.submit_action("discard");
		});
		return false;
	};

	_actions.unlock = function()
	{
		$(".unlock-invoice-swal").remove();
		swal({
			title: "Déverrouiller une facture",
			text: "La facture sera aussi dépubliée.\nCette action est protégée par mot de passe.",
			type: "input",
			customClass: "unlock-invoice-swal",
			showCancelButton: true,
			cancelButtonText: 'Annuler',
			confirmButtonClass: "btn-danger",
			confirmButtonText: 'Déverrouiller',
			closeOnConfirm: false,
			inputPlaceholder: "Mot de passe"
		}, function (inputValue){
			$.post("/login/permission", {
				privilege: 'INVOICE_UNLOCK',
				password: inputValue
			}, function(x){
				if (x.success){
					// got permission, delete using key
					_actions.submit_action("unlock", x.action, x.key);
				} else {
					// didn't get permission
					swal({
						title: "Erreur",
						text: "Mot de passe incorrect.",
						type: "error",
						confirmButtonClass: "btn-danger"
					});
				}
			}, 'json');
		});
		$(".unlock-invoice-swal").find(".form-control").attr("type", "password").attr("autocomplete", "new-password").css({
			'width' : "200px",
			'margin' : "0 auto 1.5em"
		});
	};

	_actions.saved = function()
	{
		//
	};

	return function()
	{
		// Print button
		_actions.find(".btn-action-print").on("click", _actions.print);

		// Send via email
		_actions.find(".btn-action-email").on("click", _actions.email);

		// Delete invoice
		_actions.find(".btn-action-delete").on("click", _actions.delete);

		// Publish invoice
		_actions.find(".btn-action-publish").on("click", _actions.publish);

		// Discard changes
		_actions.find(".btn-action-discard").on("click", _actions.discard);

		// Unlock invoice
		_actions.find(".btn-action-unlock").on("click", _actions.unlock);

		return _actions;
	}();
};
